import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxCurrencyModule } from 'ngx-currency';
import { NgxMaskModule } from 'ngx-mask';
import { InputMaskModule } from 'racoon-mask-raw';
import { MaterialModule } from 'src/app/material-module';
import { AlertModule } from 'src/app/shared/components/alert/alert.module';
import { FormFieldErrorModule } from 'src/app/shared/components/form-field-error/form-field-error.module';
import {
  SpinnerAngularmaterialModule,
} from 'src/app/shared/components/spinner-angularmaterial/spinner-angularmaterial.module';

import { DadosFormRoutingModule } from '../dados-form/dados-form-routing.module';
import { DoadorComponent } from './doador.component';

@NgModule({
  declarations: [DoadorComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    AlertModule,
    SpinnerAngularmaterialModule,
    DadosFormRoutingModule,
    FormsModule,
    NgxMaskModule,
    RouterModule,
    HttpClientModule,
    FormFieldErrorModule,
    InputMaskModule,
    NgxCurrencyModule
  ],
  exports: [DoadorComponent]
})
export class DoadorModule { }
